import { User } from '@litlingo/client';

export const extractDomain = (email: string): string =>
  email.toLowerCase().match(/(?<=@)(.*)/g)?.[0] || '';

const renderInsight = (user: User, defaultValue?: string): string => {
  const insight = [];

  if (user.insight_active_chat) {
    insight.push('Chat');
  }
  if (user.insight_active_email) {
    insight.push('Email');
  }

  const insightString = insight.reduce((acc, value, idx) => {
    if (idx > 0) {
      return `${acc}, ${value}`;
    }
    return value;
  }, '');

  return insightString || defaultValue || '–';
};

export const renderPrevent = (user: User, defaultValue?: string): string => {
  const prevent = [];

  if (user.prevent_active_chat) {
    prevent.push('Chat');
  }
  if (user.prevent_active_email) {
    prevent.push('Email');
  }

  const preventString = prevent.reduce((acc, value, idx) => {
    if (idx > 0) {
      return `${acc}, ${value}`;
    }
    return value;
  }, '');

  return preventString || defaultValue || '–';
};

export const renderIntegrations = (user: User, defaultValue?: string): string => {
  const response: string[] = [];

  if (user.insight_active_chat || user.insight_active_email) {
    response.push('Insight');
  }

  if (user.prevent_active_chat || user.prevent_active_email) {
    response.push('Prevent');
  }

  return response.join(' & ') || defaultValue || '–';
};

export default renderInsight;
